<!--年度各类型农机报废补贴额-->
<template>
  <div class="location-number">
    <seamless-scroll
      class="locaiton-scroll"
      :data='scrapSubsidyList'
      :class-option="classOption"
    >
      <div
        class="subsidy-box"
        v-for="(item,index) in scrapSubsidyList"
        :key="index"
      >
        <div class="item-left item-common" v-if="item.left">
          <div>
            <span :data-content="numberFloatSeparatorCompute(item.left.scrapSubsidyAmount)">{{item.left.scrapSubsidyAmount || 0 | toThousandFloatFilter}}</span>万元
          </div>
          <p style="fontStyle: normal;">{{item.left.model}}</p>
        </div>
        <div class="item-right">
          <img src="@/assets/images/governmentAffairs/scrapSubsidy/bg_bf_bata_line.png"></img>
          <div class="item-common special-margin" v-if="item.right">
            <div>
              <span :data-content="numberFloatSeparatorCompute(item.right.scrapSubsidyAmount)">{{item.right.scrapSubsidyAmount || 0 | toThousandFloatFilter}}</span>万元
            </div>
            <p style="fontStyle: normal">{{item.right.model}}</p>
          </div>
        </div>
      </div>
    </seamless-scroll>

  </div>
</template>

<script>
export default {
  name: 'machinerySubsidy',
  props: {
    scrapSubsidyList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      classOption: {
        step: 0.5,
        limitMoveNum: 3
      },
 
    }
  },
  computed: {
    // ...mapGetters(['getActiveYear']),
    numberFloatSeparatorCompute() {
      return function(number){
        let num = number;
        if(!number) {
          num = 0;
        }
        return num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
    },

  },
  methods: {
 
  },
}
</script>
<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}


.location-number {
  height: 100%;
  padding-left: vh(9);
  margin-top: vh(10);
  font-family: Microsoft YaHei;
  display: flex;
  flex-direction: column;
  .locaiton-scroll {
    height: 100%;
    overflow: hidden;
  }
  .subsidy-box {
    display: flex;
    flex: 1;
    align-items: center;
    width: vw(457);
    height: vh(75);
    background: url("../../../../assets/images/governmentAffairs/scrapSubsidy/bg_bf_bata.png") no-repeat;
    background-size: 100%;
    font-family: 'Microsoft YaHei';
    .item-left {
      flex: 1;
    }
    .item-right {
      flex: 1;
      display: flex;
      margin-left: vw(-20);
      img {
        width: vw(12);
        height: vh(41);
      }
    }
    .item-common {
      font-style: italic;
      font-size: fontSize(12);
      color: #50A66E;
      margin-left: vw(24);
      span {
        position: relative;
        padding-right: vh(4);
        font-family: 'Rajdhani';
        font-weight: 600;
        font-size: fontSize(26);
        height: vh(20);
        background: linear-gradient(0deg, #8FF7B4 0%, #FFFFFF 60%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      span::before {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        text-shadow: 0px 3px 7px rgba(0,0,0,0.35);
      }
      p {
        font-size: fontSize(14);
        color: #5FFF97;  
      }
    }
    .special-margin {
      margin-left: vw(20);
    }
  }
}
</style>
